import { SnackbarProvider, useSnackbar } from 'notistack';
/* eslint-disable react-refresh/only-export-components */
import React, { createContext, ReactNode } from 'react';

interface SnackbarContextType {
  showSuccess: (message: string) => void;
  showError: (message: string) => void;
  showWarning: (message: string) => void;
  showInfo: (message: string) => void;
}

export const SnackbarContext = createContext<SnackbarContextType | undefined>(
  undefined
);

export type { SnackbarContextType };

interface SnackbarProviderProps {
  children: ReactNode;
}

export const SnackbarProviderWrapper: React.FC<SnackbarProviderProps> = ({
  children,
}) => {
  return (
    <SnackbarProvider
      preventDuplicate
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      maxSnack={3}
      autoHideDuration={4000}
      dense
      disableWindowBlurListener
      classes={{
        containerRoot: 'notistack-container-root',
      }}
      TransitionComponent={undefined}
      TransitionProps={{
        direction: 'up',
      }}
    >
      <SnackbarContextProvider>{children}</SnackbarContextProvider>
    </SnackbarProvider>
  );
};

const SnackbarContextProvider: React.FC<SnackbarProviderProps> = ({
  children,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const showSuccess = (message: string) => {
    enqueueSnackbar(message, { variant: 'success' });
  };

  const showError = (message: string) => {
    enqueueSnackbar(message, { variant: 'error' });
  };

  const showWarning = (message: string) => {
    enqueueSnackbar(message, { variant: 'warning' });
  };

  const showInfo = (message: string) => {
    enqueueSnackbar(message, { variant: 'info' });
  };

  const value: SnackbarContextType = {
    showSuccess,
    showError,
    showWarning,
    showInfo,
  };

  return (
    <SnackbarContext.Provider value={value}>
      {children}
    </SnackbarContext.Provider>
  );
};
